import { API } from '@strapi/client';

import { IS_PROD } from 'modules/common/constants/env';
import { web3Api } from 'store/queries';

import { ReferralProgram, ReferralProgramResponse } from '../types';
import { mapReferralProgramResponseToReferralProgram } from './utils/mapReferralProgramResponseToReferralProgram';
import { strapiClient } from '../client';

type Response = API.DocumentResponseCollection<ReferralProgramResponse>;

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchReferralPrograms },
  useFetchReferralProgramsQuery,
  useLazyFetchReferralProgramsQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchReferralPrograms: build.query<ReferralProgram[], void>({
      queryFn: async () => {
        const referralProgramsCollection = strapiClient.collection(
          'api/web3-api-referral-programs',
        );

        const response = (await referralProgramsCollection.find({
          populate: {
            cover: {
              fields: ['url'],
            },
          },
          filters: IS_PROD
            ? {
                stageOnly: {
                  $eq: false,
                },
              }
            : undefined,
        })) as Response;

        const data = response.data.map(
          mapReferralProgramResponseToReferralProgram,
        );

        return { data };
      },
    }),
  }),
  overrideExisting: true,
});
